import { render, staticRenderFns } from "./CommunityListAccordionItem.vue?vue&type=template&id=77e231f4&"
import script from "./CommunityListAccordionItem.vue?vue&type=script&lang=js&"
export * from "./CommunityListAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports